<!-- <app-page-header-png [isCurveGray]="true" header={{language.privacy_policy}} backgroundPath="assets/images/lead/bg.jpg"></app-page-header-png> -->
<ngx-ui-loader></ngx-ui-loader>
<div class="container">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <!-- contant -->
            <div [innerHTML]='this.privacy_content'></div>
            <!-- content -->
        </div>
    </div>    
</div>